module.exports = __webpack_public_path__ + "img/pos2.8b374631.webp";